<div class="w-full h-full">
  <iframe
    class="w-full h-full"
    [src]="url | safe"
    frameborder="0"
    allowfullscreen
  ></iframe>
</div>
